
import { VNodeChild } from "vue";

const Node = (props: { node: VNodeChild }): VNodeChild => props.node;

export default Node;
